export const CLEAR_RAPIDFORM_STORE = 'CLEAR_RAPIDFORM_STORE'

export const CLEAR_MYZONE_STORE = 'CLEAR_MYZONE_STORE'

export const CLEAR_AUTHENTICATION_STORE = 'CLEAR_AUTHENTICATION_STORE'
